export const CIFRE_ID_PAZIENTE_API = "numeroCifre";
export const CIFRE_ID_PAZIENTE_JSON = "cifreIdPaziente";
// header request
export const TENANT_ID = "x-event-id";
export const NAVIGATION_FROM_REQUEST_HEADER = "x-navigation-from";
// Variabili per il locale storage
export const WELCOME_PAGE_VISITED = "welcomeVisited";
export const NOTIFICATION_PERMISSION_SETTED = "permissionJustSetted";
export const SHOW_INSTALLATION_ALERT = "showInstallationAlert";
export const SHOW_IOS_INSTALLATION_GUIDE = "showIosInstallationGuide";

// Permessi notifiche
export const NOTIFICHE_NON_IMPOSTATE = "default";
export const NOTIFICHE_CONCESSE = "granted";
export const NOTIFICHE_NEGATE = "denied";
